import { AllowChangeGrid } from '../../../../services/modules/product-colors-packs/product-colors-packs.types';
import { AvailabilityEnum } from '../../ProductTypes';

export enum KitCombinationTypes {
  KIT_ITEM = 'KIT_ITEM',
  CLOSED_KIT = 'CLOSED_KIT',
}

export interface ClosedKitCombination {
  type: KitCombinationTypes.CLOSED_KIT;
  kitAvailableAmount: number | null;
  kitCode: string;
  kitId: string;
  kitImageUrl: string | null;
  kitName: string;
  kitWholesalePrice: number | undefined;
  orderId: string | null;
  orderCode: string | null;
  customerId: string | null;
  customerCommercialName: string | null;
  orderQuantity: number | null;
}

export interface KitItemCombination {
  type: KitCombinationTypes.KIT_ITEM;
  availability: AvailabilityEnum;
  deliveryWindowCode: string | null;
  deliveryWindowId: string | null;
  deliveryWindowName: string | null;
  deliveryWindowStartDate: string | null;
  deliveryWindowEndDate: string | null;
  productColorId: string;
  productColorCode: string;
  productColorName: string;
  productColorHexCode: string | null;
  productColorImageUrl: string | null;
  allowChangePreOrderGrid: AllowChangeGrid;
  allowChangeImmediateGrid: AllowChangeGrid;
  productId: string;
  productName: string;
  productCode: string;
  productReferenceCode: string | null;
  translationId: string | null;
  translationValue: string | null;
  translationLanguage: string | null;
  mediaUrl: string | null;
  kitId: string;
  kitName: string;
  kitCode: string;
  kitImageUrl: string | null;
}
